import React, {useState, useEffect} from "react";
import  { Navigate, useLocation, useNavigate } from 'react-router-dom'
import Papa from "papaparse"
import '../styling/Dashboard.css';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import app, {db} from "../utils/firebase";
import checkSubmit, {parseSheet, getCols} from "../scripts/functions.js";
import { onValue, ref, set, get, query, equalTo, orderByChild, once, orderByValue, off, update } from "firebase/database";
import {FaLink, FaEdit, FaQuestionCircle, FaPlus, FaExternalLinkAlt} from "react-icons/fa";

const Dashboard = () => {
    const [alias, setAlias] = useState("");
    const [url, setURL] = useState("");
    const [feeds, setFeeds] = useState([]);
    const [show, setShow] = useState("");
    const [user, setUser] = useState(0);
    const [loading, setLoading] = useState(true);

    const [cols, setCols] = useState([]);

    const [feedTitle, setFeedTitle] = useState('');
    const [feedColor, setFeedColor] = useState("#000000");
    const [feedTheme, setFeedTheme] = useState("light");
    const [headlineCol, setHeadlineCol] = useState("");
    const [descCol, setDescCol] = useState("");
    const [footerCol, setFooterCol] = useState("");
    const [filters, setFilters] = useState([]);
    const [newFeed, setNewFeed] = useState(true);

    const [password, setPassword] = useState(false);
    const [passwordText, setPasswordText] = useState("");

    const auth = getAuth(app);

    const { state } = useLocation();

    const { startUrl } = state || { startUrl: "" };

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const s = params.get('s');
        if (s === "create") {
            setShow("create");
        } else if (s === "edit") {
            setShow("edit");
        } else {
            setShow("create");
        }
        
        setURL(startUrl);
        
        onAuthStateChanged(auth, (user) => {
            if (user) {
                setUser(user.uid);
            } else {
            }
        });
  
        if (user) {
            const userRef = ref(db, "users/" + user + "/feeds");
            const userFeeds = [];
            onValue(userRef, (snapshot) => {
                if (snapshot.val() === null) {
                    setFeeds([]);
                    setLoading(false);
                    return;
                }
                const promises = snapshot.val().map((feedAlias) => {
                    const feedRef = ref(db, "feeds/" + feedAlias + "/");
                    return get(feedRef).then((childSnapshot) => {
                        const feed = childSnapshot.val();
                        if (feed != null) {
                            userFeeds.push(feed);
                        }
                    });
                });
        
                Promise.all(promises).then(() => {
                    setFeeds(userFeeds); 
                    setLoading(false);
                });
            });
        }
        
    }, [setFeeds, user]);
    
    const Push = () => {
        if (checkSubmit(alias, url) === false) {
            return;
        }

        const dbRef = ref(db, "feeds/" + alias + "/");
        get(dbRef).then((snapshot) => {
            if (snapshot.exists()) {
                alert("This alias already exists. Please choose another.");
            } else {
                parseSheet(url);
                let fetchCols = new Promise((resolve, reject) => {
                    try {
                        Papa.parse(url, {
                            download: true,
                            header: false,
                            complete: function(results) {
                            var data = results.data
                            resolve(data[0]);
                            }
                        })
                    } catch (any) {
                        reject("Error");
                    }
                });
                fetchCols.then( 
                    (value) => {
                        setCols(value);
                        setHeadlineCol(value[0])
                        setDescCol(value[0])
                        setFooterCol(value[0])
                        setFilters(new Array(value.length).fill(false));

                        setShow("setup");
                    },
                    (error) => alert("Error")
                )    
            }
        });

    }

    const submitFeed = (isNew) => {
        if (password && passwordText === "") {
            alert("Please enter a feed password or disable password-protection.");
            return;
        }
        const dbRef = ref(db, "feeds/" + alias + "/");
        get(dbRef).then((snapshot) => {
            const data = {
                url: url,
                alias: alias,
                title: feedTitle === '' ? alias : feedTitle,
                color: feedColor,
                theme: feedTheme,
                head: headlineCol,
                desc: descCol,
                footer: footerCol,
                cols: cols,
                user: user,
                filters: filters,
                password: {enabled: password, text: passwordText}
            };
            if (isNew) {
                set(dbRef, data);
            } else {
                update(dbRef, data);
                alert("Feed updated successfully!")
            }
        })
        if (isNew) {
            get(ref(db, "users/" + user + "/feeds/")).then((snapshot) => {
                const userFeeds = snapshot.val();
                if (userFeeds === null || userFeeds === undefined || userFeeds === ""  || userFeeds == []) {
                    set(ref(db, "users/" + user + "/feeds/"), [alias]);
                } else {
                    if (!userFeeds.includes(alias)) {
                        userFeeds.push(alias);
                        set(ref(db, "users/" + user + "/feeds/"), userFeeds);
                    }
                }
            });
            alert("Feed created successfully!");
        }   

    }

    const editFeed = (feedAlias) => {
        const dbRef = ref(db, "feeds/" + feedAlias + "/");
        get(dbRef).then((snapshot) => {
            const feed = snapshot.val();
            setCols(feed.cols);
            setAlias(feed.alias)
            setURL(feed.url)
            setUser(feed.user)
            setNewFeed(false);

            setFeedTitle(feed.title)
            setFeedColor(feed.color)
            setFeedTheme(feed.theme)
            setHeadlineCol(feed.head)
            setDescCol(feed.desc)
            setFooterCol(feed.footer)
            setFilters(feed.filters)

            setPassword(feed.password.enabled);
            setPasswordText(feed.password.text);

            setShow("setup");
        })
    }

    const handleCheck = (pos) => {
        const newState = filters.map((filter, index) => 
            index ===  pos ? !filter : filter
        );

        setFilters(newState);
    }

    const passwordProtect = () => {
        if (password) {
            setPassword(false);
        } else {
            setPassword(true);
        }
    }

  return (
    <>
    {loading && <div className="dash-loader"><div className="loader"></div></div>}
    {user == 0 && !loading && <Navigate to="/login" />}
    {user !== 0 && !loading && (
      <div className="dash-layout">

        {/* ── Sidebar ── */}
        <aside className="dash-sidebar">
          <div className="dash-sidebar-header">
            <span className="dash-sidebar-title">Dashboard</span>
          </div>

          <button className="dash-new-btn" onClick={() => { setShow("create"); setNewFeed(true); setAlias(""); setURL(""); }}>
            <FaPlus size={11}/> New Feed
          </button>

          <div className="dash-sidebar-label">My Feeds</div>

          <ul className="dash-feed-list">
            {feeds && feeds.length > 0 ? feeds.map((feed, index) => (
              <li key={index} className={`dash-feed-item${show === "setup" && alias === feed.alias ? " active" : ""}`}>
                <button className="dash-feed-name" onClick={() => editFeed(feed.alias)}>
                  {feed.alias}
                </button>
                <a className="dash-feed-ext" href={"/" + feed.alias} target="_blank" rel="noreferrer">
                  <FaExternalLinkAlt size={11}/>
                </a>
              </li>
            )) : (
              <li className="dash-feed-empty">No feeds yet</li>
            )}
          </ul>
        </aside>

        {/* ── Main ── */}
        <main className="dash-main">

          {show === "create" && (
            <div className="create-feed">
              <h2>Create a new Feed</h2>
              <form>
                <label htmlFor="feedName">Feed Alias</label>
                <input type="text" id="feedName" name="feedName" onChange={(e) => setAlias(e.target.value)} value={alias} placeholder="e.g. my-resources" required />
                <div className="feedUrlLabel">
                  <FaQuestionCircle className="help-icon" onClick={() => alert("Please enter the URL of your Google Sheet. The URL should be in the format of https://docs.google.com/spreadsheets/d/your-sheet-id/export?format=csv. Remember to publish your sheet (File -> Share -> Publish to web -> CSV) to the web in order to get the URL.")} />
                  <label htmlFor="feedURL">Google Sheet URL</label>
                </div>
                <input type="url" id="feedURL" name="feedURL" onChange={(e) => setURL(e.target.value)} value={url} placeholder="https://docs.google.com/spreadsheets/d/..." required />
                <input type="submit" value="Continue →" onClick={(e) => { e.preventDefault(); Push(); }} />
              </form>
            </div>
          )}

          {show === "setup" && (
            <div className="feed-info">
              <div className="feed-info-header">
                <h2>Feed Setup</h2>
                <a className="feed-preview-link" href={"/" + alias} target="_blank" rel="noreferrer">
                  <FaExternalLinkAlt size={12}/> Preview
                </a>
              </div>
              <div className="feed-form">
                <span>Feed Title</span>
                <input type="text" value={feedTitle} onChange={ev => setFeedTitle(ev.target.value)} placeholder={alias} />

                <span>Feed Color</span>
                <input type="color" value={feedColor} onChange={ev => setFeedColor(ev.target.value)} />

                <span>Feed Theme</span>
                <select className="theme-select" value={feedTheme} onChange={ev => setFeedTheme(ev.target.value)}>
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                </select>

                <span>Column Mapping</span>
                <div className="feed-cols">
                  <div className="col-input">
                    <span>Headline</span>
                    <select value={headlineCol} onChange={ev => setHeadlineCol(ev.target.value)}>
                      {cols && cols.map((col, i) => <option key={i}>{col}</option>)}
                    </select>
                  </div>
                  <div className="col-input">
                    <span>Description</span>
                    <select value={descCol} onChange={ev => setDescCol(ev.target.value)}>
                      {cols && cols.map((col, i) => <option key={i}>{col}</option>)}
                    </select>
                  </div>
                  <div className="col-input">
                    <span>Footer</span>
                    <select value={footerCol} onChange={ev => setFooterCol(ev.target.value)}>
                      {cols && cols.map((col, i) => <option key={i}>{col}</option>)}
                    </select>
                  </div>
                </div>

                <span>Filters</span>
                <div className="filter-checklist">
                  {cols && cols.map((col, i) => (
                    <div key={i}>
                      <input type="checkbox" id={col + i} checked={filters[i]} onChange={() => handleCheck(i)} />
                      <label htmlFor={col + i}>{col}</label>
                    </div>
                  ))}
                </div>

                <span>Password Protection</span>
                <div className="password-protection">
                  <input type="checkbox" id="password-toggle" checked={password} onChange={passwordProtect} />
                  <label htmlFor="password-toggle">Require a password to access this feed</label>
                </div>
                {password && (
                  <input type="text" placeholder="Enter feed password" value={passwordText} onChange={(e) => setPasswordText(e.target.value)} />
                )}

                <button className="feed-submit" onClick={() => submitFeed(newFeed)}>
                  {newFeed ? "Create Feed" : "Save Changes"}
                </button>
              </div>
            </div>
          )}

          {show !== "create" && show !== "setup" && (
            <div className="dash-empty-state">
              <p>Select a feed from the sidebar or create a new one.</p>
            </div>
          )}
        </main>
      </div>
    )}
    </>
  )
};

export default Dashboard;